import { Persona } from "../models";

export function personaName(persona: Persona){
  return `${persona.personaPrimerApellido} ${persona.personaNombre}`;
}
